import Chaplin from 'chaplin';

const AlertService = function () {
  this.showSuccessAlert = () => {
    const successConfig = {
      type: 'alertBox.alertSuccess',
      title: 'alertBox.alertSuccessHeader',
      icon: '',
      visible: true,
      message: 'alertBox.alertSuccessText',
      timeout: 5000,
    };
    this.showAlert(successConfig);
  };

  this.showFailureAlert = () => {
    const failureConfig = {
      type: 'alertBox.alertFailure',
      title: 'alertBox.alertFailureHeader',
      icon: '',
      visible: true,
      message: 'alertBox.alertFailureText',
      timeout: 5000,
    };
    this.showAlert(failureConfig);
  };

  this.showAlert = alertConfig => {
    if (!alertConfig) {
      return;
    }

    const { type, title, icon, visible, message, timeout } = alertConfig;
    Chaplin.mediator.publish('action:alert', type, title, message, icon, visible, timeout);
  };
};

export default new AlertService();
